var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showgo)?_c('div',{staticClass:"gotop"},[_c('div',{staticClass:"gotopup",class:{'dark':_vm.themeName=='dark'},on:{"click":_vm.gotop}},[_c('i',{staticClass:"iconfont icon-dingbu"})]),_c('div',{staticClass:"gotobottom",class:{'dark':_vm.themeName=='dark'},on:{"click":_vm.gobottom}},[_c('i',{staticClass:"iconfont icon-dingbu"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }